import { normalize } from 'normalizr';

import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import {
  SiteWeatherConfiguration,
  siteWeatherConfigurationSchema,
} from '@sophocles/entities/SiteWeatherConfiguration/siteWeatherConfigurationRecord';
import { addToast } from '@sophocles/features/toast';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';

/* Receive Actions */
export const RECEIVE_SITE_WEATHER_CONFIGURATIONS = 'RECEIVE_SITE_WEATHER_CONFIGURATIONS';
export function receiveSiteWeatherConfigurations(json) {
  return {
    type: RECEIVE_SITE_WEATHER_CONFIGURATIONS,
    siteWeatherConfigurations: mapListToRecords(json, SiteWeatherConfiguration),
  };
}

/* Request Actions */
// starter request
export const REQUEST_SITE_WEATHER_CONFIGURATION = 'REQUEST_SITE_WEATHER_CONFIGURATION';
function requestSiteWeatherConfiguration(siteWeatherConfiguration_id) {
  return {
    type: REQUEST_SITE_WEATHER_CONFIGURATION,
    siteWeatherConfiguration_id,
  };
}

export const REQUEST_SITE_WEATHER_CONFIGURATION_FOR_SITE = 'REQUEST_SITE_WEATHER_CONFIGURATION_FOR_SITE';
function requestSiteWeatherConfigurationForSite(site_id) {
  return {
    type: REQUEST_SITE_WEATHER_CONFIGURATION_FOR_SITE,
    site_id,
  };
}

export const REQUEST_SITE_WEATHER = 'REQUEST_SITE_WEATHER';
function requestSiteWeather(site_id) {
  return {
    type: REQUEST_SITE_WEATHER,
    site_id,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchSiteWeatherConfiguration(siteWeatherConfiguration_id) {
  return dispatch => {
    dispatch(requestSiteWeatherConfiguration(siteWeatherConfiguration_id));
    return apiClient
      .get(`/siteweatherconfigurations/${siteWeatherConfiguration_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'siteWeatherConfigurations', siteWeatherConfigurationSchema))
      .then(json => dispatch(receiveSiteWeatherConfigurations(json.entities.siteWeatherConfigurations)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_SITE_WEATHER_CONFIGURATION)));
  };
}

export function fetchSiteWeatherConfigurationForSite(site_id) {
  return dispatch => {
    dispatch(requestSiteWeatherConfigurationForSite(site_id));
    return apiClient
      .get(`/siteweatherconfigurations/?site=${site_id}`)
      .then(checkHttpStatus)
      .then(response =>
        normalizeList(response.data.results, 'siteWeatherConfigurations', siteWeatherConfigurationSchema),
      )
      .then(json => dispatch(receiveSiteWeatherConfigurations(json.entities.siteWeatherConfigurations)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_SITE_WEATHER_CONFIGURATION_FOR_SITE)));
  };
}

/* Edit Actions */
export const EDIT_SITE_WEATHER_CONFIGURATION = 'EDIT_SITE_WEATHER_CONFIGURATION';
export function editSiteWeatherConfiguration(siteWeatherConfiguration_id) {
  return {
    type: EDIT_SITE_WEATHER_CONFIGURATION,
    siteWeatherConfiguration: siteWeatherConfiguration_id,
  };
}

export function patchSiteWeatherConfiguration(siteWeatherConfiguration_id, values) {
  return dispatch => {
    dispatch(editSiteWeatherConfiguration(siteWeatherConfiguration_id));
    return apiClient
      .patch(`/siteweatherconfigurations/${siteWeatherConfiguration_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, siteWeatherConfigurationSchema))
      .then(json => {
        dispatch(
          addToast({
            title: 'Success',
            message: 'Weather configuration updated',
            level: 'success',
            dismissible: true,
          }),
        );
        return dispatch(receiveSiteWeatherConfigurations(json.entities.siteWeatherConfigurations));
      })
      .catch(error => dispatch(genericErrorAction(error, EDIT_SITE_WEATHER_CONFIGURATION)));
  };
}

/* Create Actions */
export const CREATE_SITE_WEATHER_CONFIGURATION = 'CREATE_SITE_WEATHER_CONFIGURATION';
function sayCreateSiteWeatherConfiguration(values) {
  return {
    type: CREATE_SITE_WEATHER_CONFIGURATION,
    values: values,
  };
}

export function createSiteWeatherConfiguration(values) {
  return dispatch => {
    dispatch(sayCreateSiteWeatherConfiguration(values));
    return apiClient
      .post(`/siteweatherconfigurations/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, siteWeatherConfigurationSchema))
      .then(json => {
        dispatch(
          addToast({
            title: 'Success',
            message: 'Smart-Weather settings updated',
            level: 'success',
            dismissible: true,
          }),
        );
        return dispatch(receiveSiteWeatherConfigurations(json.entities.siteWeatherConfigurations));
      })
      .catch(error => dispatch(genericErrorAction(error, CREATE_SITE_WEATHER_CONFIGURATION)));
  };
}

/* Delete Actions */
export const DELETE_SITE_WEATHER_CONFIGURATION = 'DELETE_SITE_WEATHER_CONFIGURATION';
function sayDeleteSiteWeatherConfiguration(siteWeatherConfiguration_id) {
  return {
    type: DELETE_SITE_WEATHER_CONFIGURATION,
    siteWeatherConfiguration: siteWeatherConfiguration_id,
  };
}

export function deleteSiteWeatherConfiguration(siteWeatherConfiguration_id) {
  return dispatch =>
    apiClient
      .delete(`/siteweatherconfigurations/${siteWeatherConfiguration_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteSiteWeatherConfiguration(siteWeatherConfiguration_id)))
      .catch(error => dispatch(genericErrorAction(error, DELETE_SITE_WEATHER_CONFIGURATION)));
}
